// extracted by mini-css-extract-plugin
export var logo = "_c5-2";
export var logoWrapper = "_c5-1";
export var strip = "_c5-0";